import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { EventTemplate, EventTemplateParentChild } from "../../../types/EventTemplate";
import React, { useMemo } from "react";
import _ from "lodash";
import { useGetAllEventTemplate } from "../../../services/react-query/event_templates";
import { useParams } from "react-router-dom";

interface IEditEventTemplateChildModalProps {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
  eventTemplateChild: EventTemplateParentChild;
  setEventTemplateChild: (eventTemplateChild: EventTemplateParentChild) => void;
}

export function EditEventTemplateChildModal({ open, onClose, onSubmit, eventTemplateChild, setEventTemplateChild }: IEditEventTemplateChildModalProps) {
  const { uuid } = useParams();
  const { data: eventTemplates, isLoading } = useGetAllEventTemplate({ params: { per_page: 0, filters: { is_parent: [false] } } });
  const isValid = useMemo(() => (!_.isEmpty(eventTemplateChild.child_uuid) && !_.isNaN(eventTemplateChild.offset)), [eventTemplateChild]);

  // can't add self as child
  const eventTemplatesData = _.reject(eventTemplates?.data, { uuid });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Subevent Template</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'inline-flex', gap: 4, my: 2, width: '100%' }}>
          <Autocomplete<EventTemplate>
            fullWidth
            loading={isLoading}
            options={eventTemplatesData}
            disabled={!eventTemplateChild.new_record}
            onChange={(_, template) =>
              setEventTemplateChild({
                ...eventTemplateChild,
                child_name: template?.name ?? '',
                child_uuid: template?.uuid ?? '',
              })
            }
            getOptionLabel={(template) => template?.name ?? ''}
            value={_.find(eventTemplatesData, { uuid: eventTemplateChild.child_uuid })}
            renderInput={(params) => <TextField {...params} autoFocus fullWidth label="Event Templates" />}
          />
          <TextField
            fullWidth
            label="Offset Days"
            type="number"
            value={_.isNaN(eventTemplateChild.offset) ? '' : eventTemplateChild.offset}
            onChange={(e) =>
              setEventTemplateChild({
                ...eventTemplateChild,
                offset: e.target.value.trim() === '' ? NaN : Number(e.target.value),
              })
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={!isValid} onClick={onSubmit}>
          {eventTemplateChild.uuid === 'new' ? 'Add' : 'Update'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}